module.exports = __webpack_public_path__ + "static/media/my_freedom_ilus.51a8fa2a.jpg";